<section aria-labelledby="faq-heading" role="region">
  <h2 id="faq-heading" class="sr-only">{{ 'ACCESSIBILITY.FAQ_SECTION' | translate }}</h2>
  @for (number of [1,2,3]; track number; let i = $index) {
    <div
      class="one-question-answer-space"
      [attr.aria-labelledby]="'faq-question-' + (i + 1)">
      <h3 [id]="'faq-question-' + (i + 1)" class="faq-question">
        {{ 'LOGIN.FAQ.TAN.' + number + '.Q' | translate }}
      </h3>
      <div class="faq-answer" [attr.aria-describedby]="'faq-question-' + (i + 1)">
        {{ 'LOGIN.FAQ.TAN.' + number + '.A' | translate }}
      </div>
    </div>
  }
</section>
<section class="contact-information"
  role="region"
  [attr.aria-label]="'ACCESSIBILITY.CONTACT_INFORMATION' | translate">
  <div class="one-question-answer-space"
         [innerHTML]="(brandingSettings.translationKeys?.helpSection?.patient || brandingSettings.translationKeys?.helpSection || 'HELP.PATIENT.DEFAULT') | translate: {
         faq: (brandingSettings.faqLink === false ? '' : 'HEADER-QUESTIONS.FAQ' | translate),
         email: brandingSettings.email || ('PATIENTUS.SERVICE_EMAIL' | translate),
         telephone: brandingSettings.telephone || ('PATIENTUS.PHONE' | translate),
         callTime: brandingSettings.callTime || ('HEADER.TIME-AVAILABLE' | translate)
         }">
  </div>
</section>
